export const cartRelaunchEn = {
  cart_relaunch: {
    title: 'Cart Relaunch',
    description: 'Recover abandoned carts with automated email campaigns',

    // Settings
    settings: 'Settings',
    enabled: 'Enabled',
    disabled: 'Disabled',
    save_settings: 'Save Settings',
    relaunch_intervals: 'Relaunch Email Intervals',
    interval_1h: '1 hour after abandonment',
    interval_24h: '24 hours after abandonment',
    interval_48h: '48 hours after abandonment',

    // Analytics
    analytics: 'Analytics',
    abandoned_carts: 'Abandoned Carts',
    emails_sent: 'Emails Sent',
    open_rate: 'Open Rate',
    click_rate: 'Click Rate',
    carts_restored: 'Carts Restored',
    conversion_rate: 'Conversion Rate',
    potential_revenue: 'Potential Revenue',
    recovered_revenue: 'Recovered Revenue',
    links_clicked: 'Links Clicked',
    converted: 'Converted',

    // Funnel
    recovery_funnel: 'Recovery Funnel',

    // Table
    abandoned_carts_list: 'Abandoned Carts',
    no_abandoned_carts: 'No abandoned carts for this event',
    customer: 'Customer',
    amount: 'Amount',
    abandoned_date: 'Abandoned Date',
    status: 'Status',
    restored: 'Restored',
    pending: 'Pending',
    max_reached: 'Max Attempts',
    showing_x_of_y: 'Showing {{shown}} of {{total}}',

    // Errors
    error_loading: 'Error loading cart relaunch data',
    error_saving: 'Error saving settings',
  },
};
